import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";

const RequireRole = ({ children, requiredRole }) => {
  const location = useLocation();
  const { keycloak, initialized } = useKeycloak();

  // ✅ Wait for Keycloak to finish initializing
  if (!initialized) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="loader"></div>
      </div>
    );
  }

  // ✅ Not authenticated
  if (!keycloak.authenticated) {
    return null;
  }

  // ✅ Read roles DIRECTLY from Keycloak token (always fresh, no sessionStorage race condition)
  const clientRoles = keycloak.tokenParsed?.resource_access?.Redoms?.roles || [];
  const realmRoles = keycloak.tokenParsed?.realm_access?.roles || [];
  const allRoles = [...new Set([...clientRoles, ...realmRoles])];

  if (!requiredRole || allRoles.includes(requiredRole)) {
    return children;
  }

  return <Navigate to="/access-denied" state={{ from: location }} replace />;
};

export default RequireRole;